export const DEBUG = true;

//based on vuexy version 5.4
export const VERSION = "0.1.0";

// Backend API endpoints
// Production
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const API_CLUSTER_URL = "/v2";
export const REFRESH_TOKEN_URL = "/auth";

/**
 * Key for local storage.
 *
 * Set the key to use in local storage to hold persistant data. If logged in,
 * you can see this key by going to Chrome > dev tools > application tab,
 * then choosing "Local Storage" and "http://localhost:8080".
 *
 * @type {string}
 */

export const CLIENT_SECRET = "DXU7I6XQLpZub7eeuP0G";
export const STORAGE_KEY = "calypso-vue";

// Add your API key here
export const googleMapsApiKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
export const libraries = ["awesome-lib", "drawing", "geometry"];

// Client Secret
export const client_secret = process.env.VUE_APP_CLIENT_SECRET;

export const GMPRO = "GMPRO";
export const OPENROUTE = "OPENROUTE";
export const TOUR_PLANNING = "TOUR_PLANNING";
